import { Component, OnInit } from "@angular/core";
import { AppConfig } from 'src/app/app-config';
import { JsLoaderService } from "src/shared/services/js-loader.service";

@Component({
  selector: "app-case",
  templateUrl: "./case.component.html"
})
export class CaseComponent implements OnInit {
  constructor(private jsLoader: JsLoaderService, private config: AppConfig) {
    this.jsLoader.loadScripts();
  }
  CaseMergeVideoPath = this.config.CaseMergeVideo;
  ngOnInit() { }
}
